import { NgModule } from '@angular/core';
import { AngularMaterialModule } from '../../../material.module';
import { OptionalPlaceholderPipe } from '@lib/pipes';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { SpinnerComponent } from '@lib/components/spinner/spinner.component';
import { TableButtonComponent, TableComponent, TableDateFilterComponent, TableFilterComponent, TableLazyloadComponent } from '@lib/modules/table/components';
import { TableColumnDirective, TableFilterDirective, TableIconDirective, TypedMatCellDefDirective } from '@lib/modules/table/directives';
import { FormsModule } from '@angular/forms';

@NgModule({
    imports: [AngularMaterialModule, DragDropModule, OptionalPlaceholderPipe, SpinnerComponent, FormsModule],
    declarations: [TableComponent, TableFilterComponent, TableButtonComponent, TableLazyloadComponent, TableColumnDirective, TableFilterDirective, TypedMatCellDefDirective, TableIconDirective, TableDateFilterComponent],
    exports: [TableComponent, TableFilterComponent, TableButtonComponent, TableLazyloadComponent, TableColumnDirective, TableFilterDirective, TypedMatCellDefDirective, TableIconDirective, TableDateFilterComponent],
})
export class TableModule {}
